import CaretIcon from './component.jsx'
export default CaretIcon
